import { Box, Grid } from "@mui/material";
import "../../styles/StrategyAndVision.css";
import { TableHeadingProps } from "../../types/types";

const TableHeading: React.FC<TableHeadingProps> = ({ questionOptions }) => {
  return (
    <>
      <Box>
        <Grid
          item
          xs={12}
          lg={9}
          className="question-container table-heading"
          container
          spacing={1}
        >
          <Grid item xs={12} md={3} className="que-heading">
            Questions
          </Grid>
          <Grid item xs={12} lg={9} className="question-option-heading">
            {questionOptions.map((option: any, index: any) => (
              <Grid
                item
                xs={12}
                md={3}
                className="response-heading"
                key={index}
              >
                {option.ResponseText}
              </Grid>
            ))}
          </Grid>
        </Grid>
      </Box>
    </>
  );
};

export default TableHeading;
